import I, { useDebugValue as y } from "react";
import { g as D } from "../_commonjsHelpers-10dfc225.js";
import { s as w } from "../index-9d43cc8b.js";
import g from "./createTokenSearchSlice.js";
import P from "./createWalletSlice.js";
import R from "./createSwapSettingsSlice.js";
import x from "./createGlobalSettingsSlice.js";
import A from "./createUserOrdersSlice.js";
import T from "./createSwapSlice.js";
import V from "./createChartSlice.js";
import U from "./createBasketSlice.js";
import L from "./createModalWhatsNewSlice.js";
import O from "./createSwapParamsSlice.js";
import "../immer-548168ec.js";
import "../swap/components/tokens.js";
const h = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), o = (i, d) => {
    const s = typeof i == "function" ? i(t) : i;
    if (!Object.is(s, t)) {
      const S = t;
      t = d ?? typeof s != "object" ? s : Object.assign({}, t, s), r.forEach((f) => f(t, S));
    }
  }, n = () => t, l = { setState: o, getState: n, subscribe: (i) => (r.add(i), () => r.delete(i)), destroy: () => {
    r.clear();
  } };
  return t = e(o, n, l), l;
}, B = (e) => e ? h(e) : h;
var _ = { exports: {} }, b = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m = I, C = w;
function W(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var j = typeof Object.is == "function" ? Object.is : W, k = C.useSyncExternalStore, q = m.useRef, F = m.useEffect, M = m.useMemo, G = m.useDebugValue;
b.useSyncExternalStoreWithSelector = function(e, t, r, o, n) {
  var u = q(null);
  if (u.current === null) {
    var a = { hasValue: !1, value: null };
    u.current = a;
  } else
    a = u.current;
  u = M(function() {
    function i(c) {
      if (!d) {
        if (d = !0, s = c, c = o(c), n !== void 0 && a.hasValue) {
          var p = a.value;
          if (n(p, c))
            return S = p;
        }
        return S = c;
      }
      if (p = S, j(s, c))
        return p;
      var E = o(c);
      return n !== void 0 && n(p, E) ? p : (s = c, S = E);
    }
    var d = !1, s, S, f = r === void 0 ? null : r;
    return [function() {
      return i(t());
    }, f === null ? void 0 : function() {
      return i(f());
    }];
  }, [t, r, o, n]);
  var l = k(e, u[0], u[1]);
  return F(function() {
    a.hasValue = !0, a.value = l;
  }, [l]), G(l), l;
};
_.exports = b;
var z = _.exports;
const $ = /* @__PURE__ */ D(z), { useSyncExternalStoreWithSelector: N } = $;
function H(e, t = e.getState, r) {
  const o = N(
    e.subscribe,
    e.getState,
    e.getServerState || e.getState,
    t,
    r
  );
  return y(o), o;
}
const v = (e) => {
  const t = typeof e == "function" ? B(e) : e, r = (o, n) => H(t, o, n);
  return Object.assign(r, t), r;
}, J = (e) => e ? v(e) : v, le = J((e) => ({
  tokenSearchSlice: g(e),
  walletSlice: P(e),
  swapSettingsSlice: R(e),
  globalSettingsSlice: x(e),
  userOrdersSlice: A(e),
  swapSlice: T(e),
  chartSlice: V(e),
  modalWhatsNewSlice: L(e),
  basketSlice: U(e),
  swapParamsSlice: O(e)
}));
export {
  le as default
};
